import { memo, useCallback } from "react";
import "./style.css";

const Tabs = (props) => {
  const { tabs = [], active, setActive, className = "" } = props;

  const onChangeTab = useCallback(
    (index) => {
      setActive(index);
    },
    [active]
  );

  return (
    <div className={`d-flex my-4 tab gap-3 ${className}`}>
      {tabs.map((item, index) => (
        <div
          key={index}
          className={`p-3 tab-element ${
            active === index ? "active-tab-element" : ""
          }`}
          onClick={() => onChangeTab(index)}
        >
          <p className="m-0">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default memo(Tabs);
